function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import FormControl from "react-bootstrap/FormControl";
import "./ProjectAndTaskList.css";
import { MdAddCircleOutline } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Field, Form, Formik, FieldArray, getIn } from "formik";
import { FilterContext, UserContext, SearchContext } from "../index";
import ControlLabel from "react-bootstrap/FormLabel";
import FormGroup from "react-bootstrap/FormGroup";
import { ORGANISATION_TEAMS_QUERY, ADD_NEW_PROJECT_MUTATION, MY_PROJECTS_QUERY } from "../MyProjects/query";
import { ADD_TASK_DETAILS_MUTATION, PROJECT_TASKS_QUERY, PROJECT_DETAILS_SUMMARY_QUERY, ADD_USER_TASK_DETAILS_MUTATION } from "../ProjectDetails/query";
import { TASK_COUNT_QUERY } from "./query";
import { PROJECTS_LISTING_QUERY, TASK_USERS_QUERY, PROJECTS_LISTING_FOR_FILTER_QUERY } from "./query";
import { PROJECT_LISTING_QUERY } from "../SideMenu/query";
import { useQuery, useMutation } from "@apollo/client";
import * as Yup from "yup";
import { toast } from "react-toastify";
import SearchBar from "../SearchBar";
import moment from "moment-timezone";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { GoCalendar } from "react-icons/go";
import DatePicker from "react-datepicker";
import { arrayToStringOutput } from "../SideMenu/Header";
import Loader from "../Loader/Loader";
import Accordion from "react-bootstrap/Accordion";
import Select from "react-select";
import classNames from "classnames";
import { HiLockClosed } from "react-icons/hi";
import { MdDeleteForever, MdModeEdit, MdClose } from "react-icons/md";
var projectSchema = Yup.object().shape({
  projectName: Yup.string().trim().required("Required"),
  projectTime: Yup.number().positive().min(0, "only positive value")
});
var TaskSchema = Yup.object().shape({
  //taskName: Yup.string().trim().required("Required"),
});
var taskPriority = [{
  label: "Low",
  value: "low"
}, {
  label: "Medium",
  value: "medium"
}, {
  label: "High",
  value: "high"
}];
var DesktopTaskList = function DesktopTaskList(props) {
  var _projectListing$proje2;
  var isNavClick = props.isNavClick,
    setNavClick = props.setNavClick,
    setTaskClick = props.setTaskClick,
    addedShow = props.addedShow,
    setAddedShow = props.setAddedShow,
    projectListing = props.projectListing,
    setProjectError = props.setProjectError,
    setFieldValue = props.setFieldValue,
    taskIndex = props.taskIndex;
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    projectList = _React$useState2[0],
    setProjectList = _React$useState2[1];
  // const  [taskList, setTaskList] = React.useState([]);

  var _React$useState3 = React.useState(addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isParentNavClick = _React$useState4[0],
    setParentNavClick = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isChildNavClick = _React$useState6[0],
    setChildNavClick = _React$useState6[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    addProjectShow = _useState2[0],
    setAddProjectShow = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    addTaskShow = _useState4[0],
    setAddTaskShow = _useState4[1];
  var _React$useState7 = React.useState(""),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    searchUser = _React$useState8[0],
    setSearchUser = _React$useState8[1]; // SEARCH SETTINGS

  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    role = _React$useContext.role,
    teamId = _React$useContext.teamId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationSettings = _React$useContext.organisationSettings;
  var handleProjectClose = function handleProjectClose() {
    setAddProjectShow(false);
    setNavClick(true);
  };
  var handleProjectShow = function handleProjectShow() {
    //setNavClick(false);
    setAddProjectShow(true);
  };
  var handleTaskClose = function handleTaskClose() {
    setAddTaskShow(null);
    setNavClick(true);
  };
  var handleTaskShow = function handleTaskShow(projectId) {
    //setNavClick(false);
    setAddTaskShow(projectId);
  };
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$task, _filterUsersData$task2, _filterUsersData$task3, _filterUsersData$task4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$task = filterUsersData.taskName) === null || _filterUsersData$task === void 0 ? void 0 : (_filterUsersData$task2 = _filterUsersData$task.toLowerCase) === null || _filterUsersData$task2 === void 0 ? void 0 : (_filterUsersData$task3 = _filterUsersData$task2.call(_filterUsersData$task)) === null || _filterUsersData$task3 === void 0 ? void 0 : (_filterUsersData$task4 = _filterUsersData$task3.includes) === null || _filterUsersData$task4 === void 0 ? void 0 : _filterUsersData$task4.call(_filterUsersData$task3, searchUser.toLowerCase());
    });
  };
  React.useEffect(function () {
    var _projectListing$proje;
    // projectListing?.projectsListing?.projects.map((item) => {
    //   const { projectName, projectId } = item;
    // return

    // });

    var taskListArray = [];
    projectListing === null || projectListing === void 0 ? void 0 : (_projectListing$proje = projectListing.projectsListing) === null || _projectListing$proje === void 0 ? void 0 : _projectListing$proje.projects.map(function (item) {
      var projectName = item.projectName,
        projectId = item.projectId,
        tasks = item.tasks;
      if ((addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId) === projectId) {
        setProjectList([{
          projectName: addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectName,
          projectId: addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId,
          tasks: tasks
        }]);
      }
    });
  }, [addedShow]);

  //console.log("projectListing", projectListing?.projectsListing?.projects);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "navbar-collapse-project-task-list-card-searchbox-wrapper"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: searchUser,
    onChange: setSearchUser,
    placeholder: "Search task name"
  })), /*#__PURE__*/React.createElement("div", {
    className: "navbar-collapse-project-task-list-card-searchbox-wrapper-div"
  }), /*#__PURE__*/React.createElement("div", {
    id: "project-and-task-selection-navbar",
    style: {
      height: "auto"
    },
    className: "navbar-collapse-project-task project-and-task-selection-navbar-collapse project-and-task-selection-collapse ".concat(isNavClick ? "in" : "")
  }, /*#__PURE__*/React.createElement("ul", {
    className: "project-task-selection-nav project-task-selection-navbar-nav"
  }, (projectListing === null || projectListing === void 0 ? void 0 : (_projectListing$proje2 = projectListing.projectsListing) === null || _projectListing$proje2 === void 0 ? void 0 : _projectListing$proje2.projects).map(function (list, index) {
    var projectName = list.projectName,
      projectId = list.projectId,
      tasks = list.tasks;
    // console.log(addedShow?.projectName, addedShow?.projectName === projectName);
    if ((addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId) === projectId) {
      return /*#__PURE__*/React.createElement("li", {
        className: "project-and-task-selection-dropdown project-and-task-selection-open"
      }, tasks.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
        className: "project-and-task-selection-dropdown-menu project-task-selection-list-task-dropdown-menu"
      }, userWithSearch(tasks).map(function (taskList, index) {
        var taskName = taskList.taskName,
          taskId = taskList.taskId;
        // console.log(taskList);
        if ((addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId) === projectId) {
          return /*#__PURE__*/React.createElement("li", {
            onClick: function onClick() {
              setAddedShow({
                projectId: projectId,
                projectName: projectName,
                taskId: taskId,
                taskName: taskName
              });
              setNavClick(false);
              if (taskIndex >= 0) {
                setFieldValue("tasks[".concat(taskIndex, "].projectId"), projectId);
                setFieldValue("tasks[".concat(taskIndex, "].projectName"), projectName);
                setFieldValue("tasks[".concat(taskIndex, "].taskId"), taskId);
                setFieldValue("tasks[".concat(taskIndex, "].taskName"), taskName);
              }
              setTaskClick(false);
              setProjectError(false);
            }
          }, /*#__PURE__*/React.createElement("a", {
            href: props.from ? "javascript:void(0);" : "#"
            // className=""
            ,
            className: "project-task-selection-task-list ".concat((addedShow === null || addedShow === void 0 ? void 0 : addedShow.taskId) == taskId ? "task-selection-list-name-content-selected" : "")
          }, /*#__PURE__*/React.createElement("div", {
            className: "project-task-selection-task-list-name",
            onClick: function onClick() {
              setAddedShow({
                projectId: projectId,
                projectName: projectName,
                taskId: taskId,
                taskName: taskName
              });
              //   if (taskIndex >= 0) {
              //     setFieldValue(`tasks[${taskIndex}].projectId`, projectId);
              //     setFieldValue(`tasks[${taskIndex}].projectName`, projectName);
              //     setFieldValue(`tasks[${taskIndex}].taskId`, taskId);
              //     setFieldValue(`tasks[${taskIndex}].taskName`, taskName);
              //   }
              setParentNavClick(false);
              setNavClick(false);
              setProjectError(false);
              setTaskClick(false);
            }
          }, " ", taskName)));
        }
      }), /*#__PURE__*/React.createElement("li", {
        role: "separator",
        className: "project-task-selection-task-list-divider project-and-task-selection-divider"
      }), props.from ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        href: props.from ? "javascript:void(0);" : "#",
        className: "project-task-selection-list-add-project project-task-selection-list-add-task project-task-selection-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "project-task-selection-list-name-content-add-task",
        onClick: function onClick() {
          return handleTaskShow(projectId);
        }
      }, /*#__PURE__*/React.createElement(MdAddCircleOutline, {
        className: "project-task-selection-list-add-project-icon"
      }), /*#__PURE__*/React.createElement("span", null, "Create new task")))) : null)) : null);
    }
  }), !props.from && (role === "Admin" || role === "Head") ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    role: "separator",
    className: "project-task-selection-task-list-divider project-and-task-selection-divider"
  }), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: props.from ? "javascript:void(0);" : "#",
    className: "project-task-selection-list-add-project project-task-selection-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-selection-list-name-content-add-project",
    onClick: function onClick() {
      return handleProjectShow();
    }
  }, /*#__PURE__*/React.createElement(MdAddCircleOutline, {
    className: "project-task-selection-list-add-project-icon"
  }), /*#__PURE__*/React.createElement("span", null, "Create new project"))))) : null)), /*#__PURE__*/React.createElement(AddProjectModal, {
    addProjectShow: addProjectShow,
    setAddProjectShow: setAddProjectShow,
    handleProjectClose: handleProjectClose,
    organisationId: organisationId,
    role: role,
    teamId: teamId,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    startDate: startDate,
    endDate: endDate,
    from: props.from ? "desktop" : null
  }), /*#__PURE__*/React.createElement(AddTaskModal, {
    addTaskShow: addTaskShow,
    setAddTaskShow: setAddTaskShow,
    handleTaskClose: handleTaskClose,
    organisationId: organisationId,
    teamId: teamId,
    startDate: moment(startDate).format("YYYY-MM-DD"),
    endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
    projectId: null,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    pageType: "task-tracker",
    from: props.from ? "desktop" : null
  }));
};
var AddProjectModal = function AddProjectModal(props) {
  var addProjectShow = props.addProjectShow,
    setAddProjectShow = props.setAddProjectShow,
    handleProjectClose = props.handleProjectClose,
    organisationId = props.organisationId,
    role = props.role,
    teamId = props.teamId,
    timeZone = props.timeZone,
    startDate = props.startDate,
    endDate = props.endDate;
  if (!addProjectShow) {
    return null;
  }
  var _useQuery = useQuery(ORGANISATION_TEAMS_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    teamsData = _useQuery.data,
    teamsError = _useQuery.error,
    teamsLoading = _useQuery.loading,
    teamsRefetch = _useQuery.refetch;
  var teamDetails = !teamsLoading && !teamsError ? teamsData === null || teamsData === void 0 ? void 0 : teamsData.organisationTeams : null;

  //console.log("teamDetails",teamDetails);

  var selectedTeamIds = [];
  if (role === "Head") {
    selectedTeamIds = teamDetails.map(function (team) {
      return team.teamId;
    });
  }
  var teamIds = teamDetails.map(function (team) {
    return team.teamId;
  });
  var _React$useState9 = React.useState(selectedTeamIds),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    teamActive = _React$useState10[0],
    setTeamActive = _React$useState10[1];
  var _React$useState11 = React.useState(""),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    searchTeam = _React$useState12[0],
    setSearchTeam = _React$useState12[1];
  var _React$useState13 = React.useState(true),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isTeamSelected = _React$useState14[0],
    setTeamSelected = _React$useState14[1];

  /**** Add New Project Submit  *****/
  var _useMutation = useMutation(ADD_NEW_PROJECT_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addNewProject = _useMutation2[0],
    addNewProjectLoading = _useMutation2[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      var projectName, projectTime, variables, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!teamActive.length) {
              _context.next = 4;
              break;
            }
            setTeamSelected(true);
            _context.next = 6;
            break;
          case 4:
            setTeamSelected(false);
            return _context.abrupt("return");
          case 6:
            //console.log("test");
            projectName = values.projectName, projectTime = values.projectTime;
            variables = {
              projectName: projectName,
              projectTime: projectTime === 0 ? null : Number(projectTime) * 60 * 60,
              teamId: teamActive,
              organisationId: organisationId
            }; //console.log("test variables",variables);
            _context.prev = 8;
            _context.next = 11;
            return addNewProject({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId
                }
              }, {
                query: PROJECTS_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null
                }
              }]
            });
          case 11:
            response = _context.sent;
            if (!(!response || !response.data || response.data.addNewProject == null)) {
              _context.next = 16;
              break;
            }
            throw new Error("error");
          case 16:
            setTeamSelected(true);
            toast.success("Project added successfully!");
            // setTeamActive
            handleProjectClose();
          case 19:
            _context.next = 24;
            break;
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](8);
            if (_context.t0.message.includes("already exist")) {
              actions.setFieldError("projectName", "Already Exists");
            }
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[8, 21]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [addNewProject, addNewProjectLoading, teamActive]);
  var teamWithSearch = function teamWithSearch(teamData) {
    if (!searchTeam) {
      return teamData;
    }
    // return teamData.filter((filterteamData) => filterteamData?.teamName?.includes(searchTeam.toLowerCase()));
    return teamData.filter(function (filterTeamsData) {
      var _filterTeamsData$team, _filterTeamsData$team2, _filterTeamsData$team3, _filterTeamsData$team4;
      return filterTeamsData === null || filterTeamsData === void 0 ? void 0 : (_filterTeamsData$team = filterTeamsData.teamName) === null || _filterTeamsData$team === void 0 ? void 0 : (_filterTeamsData$team2 = _filterTeamsData$team.toLowerCase) === null || _filterTeamsData$team2 === void 0 ? void 0 : (_filterTeamsData$team3 = _filterTeamsData$team2.call(_filterTeamsData$team)) === null || _filterTeamsData$team3 === void 0 ? void 0 : (_filterTeamsData$team4 = _filterTeamsData$team3.includes) === null || _filterTeamsData$team4 === void 0 ? void 0 : _filterTeamsData$team4.call(_filterTeamsData$team3, searchTeam.toLowerCase());
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: addProjectShow,
    onHide: handleProjectClose,
    centered: true
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "my-projects-modal-title"
  }, "New Project")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      projectName: "",
      projectTime: 0,
      team: ""
    },
    validationSchema: projectSchema,
    onSubmit: handleSubmit
  }, function (_ref2) {
    var setFieldValue = _ref2.setFieldValue;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "projectName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        placeholder: "Enter project name",
        className: "my-projects-edit-project-label-input"
      }, field)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "projectTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Estimated Time (Optional)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "my-project-add-new-project-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "number",
        min: "0",
        placeholder: "Enter estimated time in hours",
        className: "my-projects-edit-project-label-input"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "my-project-add-new-project-hours-text"
      }, "Hours")));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header-section-label"
    }, "Assign Project To"), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header-section-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-searchbox-wrapper"
    }, /*#__PURE__*/React.createElement(SearchBar, {
      value: searchTeam,
      onChange: setSearchTeam,
      placeholder: "Search team name"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "my-projects-modal-content-person-name-header-button",
      onClick: function onClick() {
        setTeamActive(teamIds);
        setTeamSelected(true);
      }
    }, "Assign All Teams")))), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-listing"
    }, teamWithSearch(teamDetails).map(function (team, index) {
      var teamFirstName = team.teamName.match(/\b(\w)/g);
      var teamNameIcon = teamFirstName.join("");
      return /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-person-name-listing-card-content",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-person-name-listing-card-content-person",
        onClick: function onClick() {
          setTeamSelected(true);
          setTeamActive(function (prev) {
            return prev.includes(team.teamId) ? prev.filter(function (a) {
              return a !== team.teamId;
            }) : [].concat(_toConsumableArray(prev), [team.teamId]);
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-person-name-listing-card-content-person-icon"
      }, team.teamName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-header-team-name"
      }, team.teamName)), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-team-name"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: team.teamId,
        name: "myRadioGroup",
        className: "create-project-team-selection-control-checkbox",
        checked: teamActive.includes(team.teamId),
        onChange: function onChange() {
          setTeamSelected(true);
          setTeamActive(function (prev) {
            return prev.includes(team.teamId) ? prev.filter(function (a) {
              return a !== team.teamId;
            }) : [].concat(_toConsumableArray(prev), [team.teamId]);
          });
        }
      })));
    }), !teamWithSearch(teamDetails).length ? /*#__PURE__*/React.createElement("div", {
      className: "text-muted text-center"
    }, "No team found for \"".concat(searchTeam, "\"\n                              ")) : null), !isTeamSelected ? /*#__PURE__*/React.createElement("div", {
      className: "create-project-team-selection-error-message"
    }, "Select atleast one team") : null)), /*#__PURE__*/React.createElement(Row, {
      className: "add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "my-projects-modal-save-button",
      type: "submit"
    }, addNewProjectLoading ? "Loading..." : "Add New Project")))))));
  })));
};
export var AddTaskModal = function AddTaskModal(props) {
  var _userWithSearch, _userWithSearch2;
  var addTaskShow = props.addTaskShow,
    setAddTaskShow = props.setAddTaskShow,
    handleTaskClose = props.handleTaskClose,
    organisationId = props.organisationId,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    timeZone = props.timeZone,
    pageType = props.pageType,
    projectId = props.projectId;
  if (addTaskShow == null) {
    return null;
  }
  var _React$useContext2 = React.useContext(FilterContext),
    organisationSettings = _React$useContext2.organisationSettings,
    role = _React$useContext2.role;
  var _React$useState15 = React.useState([]),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    userActive = _React$useState16[0],
    setUserActive = _React$useState16[1];
  var _React$useState17 = React.useState(""),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    searchUser = _React$useState18[0],
    setSearchUser = _React$useState18[1];
  var _React$useState19 = React.useState(true),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isUserSelected = _React$useState20[0],
    setUserSelected = _React$useState20[1];
  var _React$useState21 = React.useState(null),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    manualStartDate = _React$useState22[0],
    setManualStartDate = _React$useState22[1];
  var _React$useState23 = React.useState(null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    taskStartDate = _React$useState24[0],
    setTaskStartDate = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isManualDatePickerOpen = _React$useState26[0],
    setIsManualDatePickerOpen = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isAddAndCreate = _React$useState28[0],
    setIsAddAndCreate = _React$useState28[1];
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    istaskDesErr = _React$useState30[0],
    setIstaskDesErr = _React$useState30[1];
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    isCheck = _React$useState32[0],
    setIsCheck = _React$useState32[1];
  var _React$useState33 = React.useState(true),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    isPriorityCheck = _React$useState34[0],
    setIsPriorityCheck = _React$useState34[1];
  var _React$useState35 = React.useState("false"),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    isUserNavCheck = _React$useState36[0],
    setIsUserNavCheck = _React$useState36[1];
  var formRef = React.useRef();
  var _React$useContext3 = React.useContext(UserContext),
    user = _React$useContext3.user;
  var _useQuery2 = useQuery(TASK_USERS_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      skip: !organisationId
    }),
    usersData = _useQuery2.data,
    usersError = _useQuery2.error,
    usersLoading = _useQuery2.loading,
    usersRefetch = _useQuery2.refetch;
  React.useEffect(function () {
    if (usersData !== null && usersData !== void 0 && usersData.getTaskUserDetails) {
      var _usersData$getTaskUse;
      var selectedUserIds = usersData === null || usersData === void 0 ? void 0 : (_usersData$getTaskUse = usersData.getTaskUserDetails) === null || _usersData$getTaskUse === void 0 ? void 0 : _usersData$getTaskUse.map(function (team) {
        return team.userId;
      });
      setUserActive(selectedUserIds);
    }
  }, [usersData]);
  var userDetails = !usersLoading && !usersError ? usersData === null || usersData === void 0 ? void 0 : usersData.getTaskUserDetails : null;
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  var _useMutation3 = useMutation(ADD_TASK_DETAILS_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    addTaskDetails = _useMutation4[0],
    addTaskDetailsLoading = _useMutation4[1].loading;
  var _useMutation5 = useMutation(ADD_USER_TASK_DETAILS_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    addUserTaskDetails = _useMutation6[0],
    addUserTaskDetailsLoading = _useMutation6[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, actions) {
      var taskName, taskTime, priority, projectUsers, variables, _response$data, response, _response$data2, _response$data3;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            taskName = values.taskName, taskTime = values.taskTime, priority = values.priority, projectUsers = values.projectUsers;
            variables = {
              taskName: taskName,
              projectId: addTaskShow,
              organisationId: organisationId,
              taskTime: taskTime === null ? null : Number(taskTime) * 60 * 60,
              userId: isPriorityCheck ? userActive : [],
              dueDate: manualStartDate,
              timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              priority: priority,
              startDate: taskStartDate
            };
            setIstaskDesErr(false);
            _context2.prev = 3;
            _context2.next = 6;
            return addTaskDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }, {
                query: PROJECTS_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null
                }
              }, {
                query: PROJECTS_LISTING_FOR_FILTER_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null
                }
              }, {
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDate,
                  endDate: endDate,
                  taskStatus: null,
                  search: null,
                  limit: 25,
                  offset: 0,
                  timezone: timeZone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: timeZone
                }
              }, {
                query: TASK_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  role: role
                }
              }]
            });
          case 6:
            response = _context2.sent;
            if (response && (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.addTaskDetails) != "error") {
              if (isPriorityCheck) {
                toast.success("Task added successfully!");
                handleTaskClose();
              } else {
                setIsUserNavCheck(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.addTaskDetails);
              }
            } else {
              actions.setFieldError("formError", response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.addTaskDetails);
            }
            _context2.next = 13;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);
            actions.setFieldError("formError", _context2.t0.message);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 10]]);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }(), [addTaskDetails, addTaskDetailsLoading, manualStartDate, isAddAndCreate, taskStartDate, userActive, isPriorityCheck]);
  var handleSubmitButton = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var variables, _response$data4, response, _usersData$getTaskUse2, selectedUserIds;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          variables = {
            taskName: formRef.current.values.taskName.trim() == "" ? null : formRef.current.values.taskName,
            projectId: addTaskShow,
            organisationId: organisationId,
            taskTime: formRef.current.values.taskTime === "" ? null : Number(formRef.current.values.taskTime) * 60 * 60,
            userId: !isPriorityCheck ? userActive : [],
            dueDate: manualStartDate,
            timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
            priority: formRef.current.values.priority,
            startDate: taskStartDate
          };
          _context3.prev = 1;
          _context3.next = 4;
          return addTaskDetails({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: PROJECT_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }, {
              query: PROJECTS_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null
              }
            }, {
              query: PROJECT_TASKS_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: startDate,
                endDate: endDate,
                taskStatus: null,
                search: null,
                limit: 25,
                offset: 0,
                timezone: timeZone,
                role: role,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }, {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                timezone: timeZone
              }
            }, {
              query: TASK_COUNT_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: null,
                projectId: [projectId],
                taskId: null,
                role: role
              }
            }]
          });
        case 4:
          response = _context3.sent;
          setIsAddAndCreate(false);
          if (response && (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.addTaskDetails) == true) {
            setManualStartDate(null);
            selectedUserIds = usersData === null || usersData === void 0 ? void 0 : (_usersData$getTaskUse2 = usersData.getTaskUserDetails) === null || _usersData$getTaskUse2 === void 0 ? void 0 : _usersData$getTaskUse2.map(function (user) {
              return user.userId;
            });
            setUserActive(selectedUserIds);
            setIsPriorityCheck(false);
            setIsCheck(false);
            toast.success("Task added successfully!");
            formRef.current.resetForm({
              taskName: "",
              taskTime: 10,
              projectUsers: []
            });
            formRef.current.setStatus({
              success: true
            });
          } else {
            setIstaskDesErr(true);
          }
          _context3.next = 12;
          break;
        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3["catch"](1);
          setIstaskDesErr(true);
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 9]]);
  })), [addTaskDetails, addTaskDetailsLoading, manualStartDate, isAddAndCreate, taskStartDate, userActive, isPriorityCheck]);
  var handleUserSubmitButton = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var variables, _response$data5, response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          variables = {
            projectId: addTaskShow,
            organisationId: organisationId,
            taskId: isUserNavCheck,
            userId: userActive
          };
          _context4.prev = 1;
          _context4.next = 4;
          return addUserTaskDetails({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: PROJECT_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }, {
              query: PROJECTS_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null
              }
            }, {
              query: PROJECTS_LISTING_FOR_FILTER_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null
              }
            }, {
              query: PROJECT_TASKS_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: startDate,
                endDate: endDate,
                taskStatus: null,
                search: null,
                limit: 25,
                offset: 0,
                timezone: timeZone,
                role: role,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }, {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                timezone: timeZone
              }
            }, {
              query: TASK_COUNT_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: null,
                projectId: [projectId],
                taskId: null,
                role: role
              }
            }]
          });
        case 4:
          response = _context4.sent;
          if (response && (response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.addUserTaskDetails) == true) {
            toast.success("Task added successfully!");
            handleTaskClose();
          } else {
            setIstaskDesErr(true);
          }
          _context4.next = 11;
          break;
        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](1);
          setIstaskDesErr(true);
        case 11:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 8]]);
  })), [addUserTaskDetails, addUserTaskDetailsLoading, userActive, isPriorityCheck, isUserNavCheck]);
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp, _filterUsersData$disp2, _filterUsersData$disp3, _filterUsersData$disp4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp = filterUsersData.displayName) === null || _filterUsersData$disp === void 0 ? void 0 : (_filterUsersData$disp2 = _filterUsersData$disp.toLowerCase) === null || _filterUsersData$disp2 === void 0 ? void 0 : (_filterUsersData$disp3 = _filterUsersData$disp2.call(_filterUsersData$disp)) === null || _filterUsersData$disp3 === void 0 ? void 0 : (_filterUsersData$disp4 = _filterUsersData$disp3.includes) === null || _filterUsersData$disp4 === void 0 ? void 0 : _filterUsersData$disp4.call(_filterUsersData$disp3, searchUser.toLowerCase());
    });
  };
  var handleChange = function handleChange(e) {
    setIsManualDatePickerOpen(!isManualDatePickerOpen);
    setManualStartDate(e);
  };
  var handleStartChange = function handleStartChange(e) {
    setTaskStartDate(e);
  };
  var handleKey = function handleKey(data) {
    if (data == "setting") {
      setIsCheck(function (prev) {
        return prev === true ? false : true;
      });
    } else if (data == "private") {
      setIsPriorityCheck(function (prev) {
        return prev === true ? false : true;
      });
    }
  };
  var taskUsersOnChange = function taskUsersOnChange(setFieldValue) {
    return function (selectedArray) {
      if (selectedArray && selectedArray.some(function (el) {
        return el.value === "everyone";
      })) {
        setFieldValue("projectUsers", ["everyone"]);
      } else if (selectedArray && selectedArray.some(function (el) {
        return el.value === "all teams";
      })) {
        setFieldValue("projectUsers", ["all teams"]);
      } else if (selectedArray && !selectedArray.some(function (el) {
        return el.value === "everyone" || el.value === "all teams";
      })) {
        setFieldValue("projectUsers", selectedArray.map(function (item) {
          return item.value;
        }));
      } else {
        setFieldValue("projectUsers", []);
      }
    };
  };
  var errorMessage = function errorMessage(errors, touched, name) {
    var error = getIn(errors, name);
    var touch = getIn(touched, name);
    if (touch && error) {
      return /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, error);
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleTaskClose,
    centered: true,
    className: "project-task-modals-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, isUserNavCheck == "false" ? "Create New Task" : "Assign Task To")), /*#__PURE__*/React.createElement(Modal.Body, null, isUserNavCheck == "false" ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      taskName: [""],
      taskTime: "",
      priority: "",
      projectUsers: []
    }
    //validationSchema={TaskSchema}
    ,
    enableReinitialize: true,
    onSubmit: handleSubmit,
    innerRef: formRef
  }, function (_ref6) {
    var setFieldValue = _ref6.setFieldValue,
      errors = _ref6.errors,
      values = _ref6.values,
      touched = _ref6.touched;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "tasks-modal-cols"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "project-task-modals-edit-task-label-name"
    }, "Task title ", /*#__PURE__*/React.createElement("sup", {
      className: "project-task-modals-edit-task-label-name-star"
    }, "*")), /*#__PURE__*/React.createElement(FieldArray, {
      name: "taskName",
      render: function render(taskArrayHelpers) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, values.taskName.map(function (task, taskIndex) {
          var teamError = errorMessage(errors, touched, "taskName[".concat(taskIndex, "]"));
          return /*#__PURE__*/React.createElement("div", {
            className: "create-new-task-whole-div-new"
          }, /*#__PURE__*/React.createElement("div", {
            className: "create-new-task-whole-div-new-textbox"
          }, /*#__PURE__*/React.createElement(FormGroup, null, teamError, /*#__PURE__*/React.createElement(Field, {
            as: Form.Control,
            type: "text",
            name: "taskName[".concat(taskIndex, "]"),
            value: task,
            required: true,
            placeholder: "e.g. Research and Analysis",
            isInvalid: teamError != null,
            className: "form-control"
          }))), /*#__PURE__*/React.createElement("div", {
            className: ""
          }, values.taskName.length !== 1 ? /*#__PURE__*/React.createElement(Button, {
            variant: "outline-secondary",
            className: "create-new-task-whole-div-new-button",
            size: "md",
            onClick: function onClick() {
              return taskArrayHelpers.remove(taskIndex);
            }
          }, "-") : /*#__PURE__*/React.createElement(Button, {
            variant: "outline-secondary",
            className: "create-new-task-whole-div-new-button",
            size: "md",
            disabled: true
          }, "-")));
        }), /*#__PURE__*/React.createElement("div", {
          className: "employee-row justify-content-md-center"
        }, /*#__PURE__*/React.createElement(Button, {
          className: "create-new-task-whole-div-add-new-team",
          variant: "link",
          onClick: function onClick() {
            return taskArrayHelpers.push("");
          }
        }, "+ Add more task")));
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "task-modal-private-toggle-div"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "project-tasks-modal-content-header-setting"
    }, /*#__PURE__*/React.createElement(HiLockClosed, {
      className: "project-tasks-modal-content-header-setting-icon"
    }), " Assign this task to all members in the project"), /*#__PURE__*/React.createElement("div", {
      className: "task-modal-private-toggle-div-command-line"
    }, "You can assign the selective members to this task by unselecting this option")), /*#__PURE__*/React.createElement("div", {
      className: "tasks-rule-uparrow toggle-switch",
      onClick: function onClick() {
        return handleKey("private");
      }
    }, /*#__PURE__*/React.createElement("label", {
      "for": "chkTest"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("toggle-track", {
        "toggle-track-nav-right-div": isPriorityCheck
      })
    })))), /*#__PURE__*/React.createElement(Accordion, {
      className: "task-modal-accordion-whole"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return handleKey("setting");
      }
    }, /*#__PURE__*/React.createElement(Accordion.Toggle, {
      as: Button,
      variant: "link",
      eventKey: "0",
      className: "task-modal-content-header-team-name-acc"
    }, /*#__PURE__*/React.createElement("span", {
      className: "project-tasks-modal-content-header-setting"
    }, isCheck ? "Hide advanced settings" : "Show advanced settings"), /*#__PURE__*/React.createElement("div", {
      className: "tasks-rule-uparrow toggle-switch"
    }, /*#__PURE__*/React.createElement("label", {
      "for": "chkTest"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("toggle-track", {
        "toggle-track-nav-right-div": isCheck
      })
    }))))), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: "0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-acc-collapse-whole-div-data"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-date-whole-div-data"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "taskTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "project-task-section-whole-input-div"
        //className="my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "project-task-modals-edit-task-label-name"
      }, "Estimated Time (Optional)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "project-tasks-modals-add-time-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "number",
        min: "0",
        placeholder: "e.g. 10",
        className: "task-add-placeholder"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "project-task-modal-add-new-project-hours-text"
      }, "Hours")));
    })), /*#__PURE__*/React.createElement("div", {
      className: "project-task-due-date"
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "project-task-modals-edit-task-label-name"
    }, "Due Date (Optional)"), /*#__PURE__*/React.createElement(DatePicker, {
      id: "task-due-date",
      dateFormat: "dd/MM/yyyy",
      selected: manualStartDate,
      onChange: handleChange,
      isClearable: true,
      className: "task-details-due-date-date-picker",
      placeholderText: "Select due date",
      autoComplete: "off"
      // open={isManualDatePickerOpen}
      // inline
    }))), /*#__PURE__*/React.createElement("div", {
      className: "task-priority-whole-div-data"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-add-modal-priority-div"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "priority"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "project-task-section-whole-input-div"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "project-task-modals-edit-task-label-name"
      }, "Priority"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        defaultValue: "",
        required: true
      }, field), /*#__PURE__*/React.createElement("option", {
        value: null
      }, "None"), taskPriority.map(function (task) {
        return /*#__PURE__*/React.createElement("option", {
          value: task.value
        }, task.label);
      })));
    })))))))), /*#__PURE__*/React.createElement(Row, {
      className: ""
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-list-modal-save-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "project-task-modals-save-button",
      type: "submit",
      disabled: addTaskDetailsLoading && isAddAndCreate == false
    }, addTaskDetailsLoading && isAddAndCreate == false ? "Loading..." : "Add Task"), " "), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error my-projects-modal-form-error"
    }, errors.formError) : null)))));
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-content-person-name-header-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-content-person-name-header-section-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-searchbox-wrapper"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: searchUser,
    onChange: setSearchUser,
    placeholder: "Search employee name"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-user-label-section-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-user-label-section"
  }, "Project members"), (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
    className: "tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive([]);
      setUserSelected(true);
    }
  }, "Unselect All Employees") : /*#__PURE__*/React.createElement("p", {
    //variant="outline-secondary"
    className: "tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive(userIds);
      setUserSelected(true);
    }
  }, "Select All Employees")), /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-listing"
  }, usersLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch = userWithSearch(userDetails)) !== null && _userWithSearch !== void 0 && _userWithSearch.length ? (_userWithSearch2 = userWithSearch(userDetails)) === null || _userWithSearch2 === void 0 ? void 0 : _userWithSearch2.map(function (user, index) {
    var teamFirstName = user.displayName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person",
      onClick: function onClick() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-header-team-name"
    }, user.displayName)), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-team-name"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "create-project-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      onChange: function onChange() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    })));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No member found for \"".concat(searchUser, "\" ")))), /*#__PURE__*/React.createElement("div", {
    className: "project-task-list-modal-save-button"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-task-modals-save-button",
    onClick: function onClick() {
      handleUserSubmitButton();
    },
    disabled: addUserTaskDetailsLoading && isAddAndCreate == false
  }, addUserTaskDetailsLoading && isAddAndCreate == false ? "Loading..." : "Done")))));
};
export default DesktopTaskList;